module.exports = __webpack_public_path__ + "static/img/WeChatcustomerservice.6771e4d2.png";